import React, { useCallback, useMemo, useState } from 'react';
import { Box } from '@common-fe/common-fe';

import ActivityLog from '@/modules/ActivityLog';
import { SpendTracker } from '@/modules/deductibles';
import { PersonalInformationPayload } from '@/modules/employee/Employee/PersonalInformation/hooks/usePersonalInformationState';

import { useGetHealthPlanYears } from '../SpendTracker/hooks';

import { HealthPlanSpendTrackerDetailsHeader } from './HealthPlanSpendTrackerDetailsHeader';
import { TiersModule } from './TiersModule';

interface HealthPlanSpendTrackerDetailsProps {
  healthPlanName?: string;
  onHealthPlanNameChange: (name: string) => void;
  healthPlanYearId?: string;
  employeeData: Partial<PersonalInformationPayload> | null;
}

export const HealthPlanSpendTrackerDetails: React.FC<HealthPlanSpendTrackerDetailsProps> = ({
  healthPlanName,
  onHealthPlanNameChange,
  healthPlanYearId,
  employeeData,
}) => {
  const [healthPlanId, setHealthPlanId] = useState<string>();
  const [healthPlanCoverageLevel, setHealthPlanCoverageLevel] = useState<string>();
  const { formattedData } = useGetHealthPlanYears(employeeData?.internalId);

  const currentPlanYear = useMemo(
    () => formattedData?.find((item) => item.id == healthPlanYearId),
    [formattedData, healthPlanYearId]
  );

  const employeeUser = useMemo(
    () => ({
      id: `${employeeData?.internalId || ''}`,
      fullName: `${employeeData?.firstName || ''} ${employeeData?.lastName || ''}`.trim(),
    }),
    [employeeData]
  );

  const handleHealthPlanNameChange = useCallback((newName: string) => {
    onHealthPlanNameChange(newName);
  }, [onHealthPlanNameChange]);

  return (
    <Box>
      <HealthPlanSpendTrackerDetailsHeader
        healthPlanName={healthPlanName}
        healthPlanId={healthPlanId}
        healthPlanCoverageLevel={healthPlanCoverageLevel}
      />
      <SpendTracker
        employeeUser={employeeUser}
        defaultHealthPlanYearId={currentPlanYear?.id}
        onHealthPlanNameChange={handleHealthPlanNameChange}
        onHealthPlanIdChange={setHealthPlanId}
        onHealthPlanCoverageLevelChange={setHealthPlanCoverageLevel}
        isDetailsPageMode
      />
      <TiersModule />
      <Box
        data-testid="activity-log-spend-tracker"
        pad="l"
        margin={{ top: 'spacing24' }}
        background="module"
        round="container1Round"
      >
        <ActivityLog />
      </Box>
    </Box>
  );
};
